import { object } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'

const SlideHeader = ({ theme = {} }) => {
  const {
    header_background_color: headerBackgroundColor,
    logo_alignment: logoAlignment,
    logo,
  } = theme

  return (
    <div
      className={kuiperClassNames(
        'slide-header',
        `logo-align-${logoAlignment}`
      )}
      style={{ backgroundColor: headerBackgroundColor }}
    >
      {logo && <img alt="Logo" src={logo} />}
    </div>
  )
}

SlideHeader.propTypes = {
  theme: object,
}

export default SlideHeader
